import React, { useCallback, useState } from "react";
// import "@shopify/polaris/build/esm/styles.css";
import {
  BrowserRouter,
  useRoutes, // instead of "Switch"
} from "react-router-dom";
import "./Assets/Styles/globals.css";
import "./Assets/Styles/react-tagsinput.css";
import Login from "./Pages/Authentication/Login";
import NavigationLayout from "./Components/NavigationLayout";
import UsersAndPermissions from "./Pages/Settings/UsersAndPermissions";
import AddEditUser from "./Pages/Settings/AddEditUser";
import Users from "./Pages/Users/List";
import UserDetails from "./Pages/Users/UserDetails";
import Categories from "./Pages/Categories/List";
import AddEditCategory from "./Pages/Categories/AddEdit";
import Items from "./Pages/Items/List";
import AddEditItem from "./Pages/Items/AddEdit";
import Subcategories from "./Pages/Subcategories/List";
import AddEditSubcategory from "./Pages/Subcategories/AddEdit";

function App() {
  if (process.env.NODE_ENV === "production") {
    console.log = function () {};
  }

  return useRoutes([
    {
      path: "/",
      element: <Login />,
    },

    {
      path: "/admin/settings/users-and-permissions",
      element: (
        <NavigationLayout>
          <UsersAndPermissions />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/users-and-permissions/new",
      element: (
        <NavigationLayout>
          <AddEditUser type="add" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/settings/users-and-permissions/:id",
      element: (
        <NavigationLayout>
          <AddEditUser type="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/categories",
      element: (
        <NavigationLayout>
          <Categories />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/categories/new",
      element: (
        <NavigationLayout>
          <AddEditCategory mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/categories/:id",
      element: (
        <NavigationLayout>
          <AddEditCategory mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/categories/:id",
      element: (
        <NavigationLayout>
          <Categories mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/categories/:id/subcategories",
      element: (
        <NavigationLayout>
          <Subcategories />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/categories/:id/subcategories/new",
      element: (
        <NavigationLayout>
          <AddEditSubcategory mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/categories/:id/subcategories/:subcategoryId",
      element: (
        <NavigationLayout>
          <AddEditSubcategory mode="edit" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/categories/:id/subcategories/:subcategoryId/items",
      element: (
        <NavigationLayout>
          <Items />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/categories/:id/subcategories/:subcategoryId/items/new",
      element: (
        <NavigationLayout>
          <AddEditItem mode="new" />
        </NavigationLayout>
      ),
    },
    {
      path: "/admin/categories/:id/subcategories/:subcategoryId/items/:itemId",
      element: (
        <NavigationLayout>
          <AddEditItem mode="edit" />
        </NavigationLayout>
      ),
    },
  ]);
}
export default App;
